import { Box, Input, Text, Image, Button, Spinner, Divider, Progress, Heading,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  useToast,
 } from "@chakra-ui/react";
import { useEffect, useState, useRef, useContext } from "react";
import { api } from "../../services/api";
import { setFinalPriceForCartBatch } from "../../services/setFinalPriceForCartBatch";
import { theme } from "../../styles/theme";
import { useAuth } from "../../Hooks/useAuth";
import { BsDash, BsPlus } from 'react-icons/bs';
import { debounce } from 'lodash'
import { FaRegTimesCircle} from 'react-icons/fa';
import { BoozenToast } from '../BoozenToast';
import { BoozenConfirmDialog, useBoozenConfirm } from '../BoozenConfirm';
import { CartContext } from "../../Context/CartContext";
import { FaCreditCard, FaMoneyBill, FaTrashAlt  } from "react-icons/fa";


export function CartComponent() {
  const toast = useToast();
  const { confirm, confirmDialogProps } = useBoozenConfirm();
  const showToast = (type, title, description) => {
    toast({
      position: 'top',
      duration: 5000,
      isClosable: true,
      render: ({ onClose }) => (
        <BoozenToast type={type} title={title} description={description} onClose={onClose} />
      ),
    });
  };

  const [cartBatches, setCartBatches] = useState([]);
  const { user, signInUser, getUserInfo, signUpUser } = useAuth();
  const [batches, setBatches] = useState([]);
  const [products, setProducts] = useState([]);
  const [prices, setPrices] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [userCredits, setUserCredits] = useState([]);
  const [openOrders, setOpenOrders] = useState([]);

  const [amountAlreadyPurchased, setAmountAlreadyPurchased] = useState([]);
  const [useCredit, setUseCredit] = useState(false);

  const [loadingPage, setLoadingPage] = useState(true);


  const { decrementCartCounter } = useContext(CartContext);
  const [userAddress, setUserAddress] = useState({
    city: "",
    complement: "",
    neighborhood: "",
    number: "",
    postal_code: "",
    state: "",
    street: ""
  });

  const allowedCities = [
    'Belo Horizonte',
    'Nova Lima',
    'Contagem',
    'Betim',
    'Lagoa Santa'
  ];

  async function fetchOpenOrders() {
    if (user) {
      const response = await api.get(`/api/v1/users/${user.id}`)
      setOpenOrders(response.data.order_total_info.filter(e => e.payment.status === "pending").sort((a, b) => new Date(b.payment.created_at) - new Date(a.payment.created_at)))
    }
  }

  useEffect(() => {
    fetchOpenOrders();
  }, [])



  async function fetchCartBatches() {
    setLoadingPage(true);
    if (user) {
      try {
        const response = await api.get(`/api/v1/cart_batches?user_id=${user.id}`);
        setCartBatches(response.data.cart_batches)
        setBatches(response.data.batches)
        setProducts(response.data.products)
        setPrices(response.data.prices)
        setPhotos(response.data.photos)
        setAmountAlreadyPurchased(response.data.amount_already_purchased)
        setUserCredits(response.data.user_credits)
      } catch (error) {
        console.error("Error fetching user cart:", error);
      }
    } else {
      const cartData = localStorage.getItem("guestCart");
      const guestCart = cartData ? JSON.parse(cartData) : [];
      const guestBatches = guestCart.map((item) => ({
        product_id: item.product_id,
        batch_id: item.batch_id,
        quantity: item.quantity,
        amount: parseFloat(item.amount),
      }));

      setCartBatches(guestBatches);

      const batchIds = guestBatches
        .map((item) => item.batch_id)
        .filter((batchId) => batchId && batchId.toString().trim() !== "");

      if (batchIds.length > 0) {
        try {
          const response = await api.get(
            `/api/v1/cart_batches/get_guest_cart?batch_ids=${batchIds}`
          );

          // Check for missing batches
          const { missing_batch_ids, batches, products, prices, photos } =
            response.data;

          if (missing_batch_ids && missing_batch_ids.length > 0) {
            // Filter out missing batches from the local guestCart
            const updatedGuestCart = guestCart.filter(
              (item) => !missing_batch_ids.includes(item.batch_id.toString())
            );
            showToast("warning", "Itens removidos", "Alguns produtos do seu carrinho não estão mais disponíveis e foram removidos.");
            localStorage.setItem("guestCart", JSON.stringify(updatedGuestCart));
            setCartBatches(updatedGuestCart);
          }

          setBatches(batches);
          setProducts(products);
          setPrices(prices);
          setPhotos(photos);
          setAmountAlreadyPurchased(response.data.amount_already_purchased);
          setUserCredits([]);
        } catch (error) {
          console.error("Error fetching batch/product details:", error);
        }
      }
    }
    setLoadingPage(false);
  }

  useEffect(() => {
    fetchCartBatches();
  }, [user])



  const delayedQuery = useRef(
    debounce(async cartBatch => {
      const dataObject = new FormData();
      dataObject.append("cart_batch[amount]", cartBatch.amount);
      dataObject.append("cart_batch[quantity]", cartBatch.quantity);
      const response = await api.put(`/api/v1/cart_batches/${cartBatch.id}`, dataObject);
    }, 1000)
  ).current;

  function handleIncrement(cartBatch) {
    let updatedCartBatch;
    setAmountAlreadyPurchased(amountAlreadyPurchased + 1)
    const currentCartBatches = [...cartBatches]
    updatedCartBatch = currentCartBatches.find(e => e.batch_id === cartBatch.batch_id)
    ++updatedCartBatch.quantity
    const productId = batches.find(element => element.id === updatedCartBatch.batch_id).product_id
    const quantityPerBox = products.find(e => e.id === productId).quantity_per_box
    const sortedPrices = prices.filter(e => e.batch_id === updatedCartBatch.batch_id).sort((a, b) => a.unity - b.unity);
    let selectedPrice = sortedPrices[0];
    for (let i = 0; i < sortedPrices.length; i++) {
      if (updatedCartBatch.quantity >= sortedPrices[i].unity) {
        selectedPrice = sortedPrices[i];
      } else {
        break;
      }
    }
    updatedCartBatch.amount = quantityPerBox * updatedCartBatch.quantity * selectedPrice.price_per_unity
    setCartBatches(currentCartBatches);
    if (user) {
      delayedQuery(cartBatch)
    } else {
      const guestCart = JSON.parse(localStorage.getItem('guestCart')) || [];
      const updatedGuestCart = guestCart.map(item =>
        item.batch_id === cartBatch.batch_id
          ? {
              ...item,
              quantity: updatedCartBatch.quantity,
              amount: updatedCartBatch.amount
          }
          : item
      );
      localStorage.setItem('guestCart', JSON.stringify(updatedGuestCart));
    }
  }



  function handleDecrement(cartBatch) {
    if (cartBatch.quantity <= 1 ) {
      document.getElementById("button-decrement").disabled = true
      return
    }
    let updatedCartBatch;
    setAmountAlreadyPurchased(amountAlreadyPurchased - 1)
    const currentCartBatches = [...cartBatches]
    updatedCartBatch = currentCartBatches.find(e => e.batch_id === cartBatch.batch_id)
    --updatedCartBatch.quantity
    const productId = batches.find(element => element.id === updatedCartBatch.batch_id).product_id
    const quantityPerBox = products.find(e => e.id === productId).quantity_per_box
    const sortedPrices = prices.filter(e => e.batch_id === updatedCartBatch.batch_id).sort((a, b) => a.unity - b.unity);
    let selectedPrice = sortedPrices[0];
    for (let i = 0; i < sortedPrices.length; i++) {
      if (updatedCartBatch.quantity >= sortedPrices[i].unity) {
        selectedPrice = sortedPrices[i];
      } else {
        break;
      }
    }
    updatedCartBatch.amount = quantityPerBox * updatedCartBatch.quantity * selectedPrice.price_per_unity
    setCartBatches(currentCartBatches)
    if (user) {
      delayedQuery(cartBatch)
    } else {
      const guestCart = JSON.parse(localStorage.getItem('guestCart')) || [];
      const updatedGuestCart = guestCart.map(item =>
        item.batch_id === cartBatch.batch_id
          ? {
              ...item,
              quantity: updatedCartBatch.quantity,
              amount: updatedCartBatch.amount
          }
          : item
      );
      localStorage.setItem('guestCart', JSON.stringify(updatedGuestCart));
    }
  }


  async function hendleRemoveCartBatch(e, cartBatch) {
    e.preventDefault()
    const ok = await confirm({
      title: "Remover produto",
      description: "Deseja remover este produto do carrinho?",
      confirmLabel: "Remover",
      cancelLabel: "Cancelar",
      danger: true,
      icon: "🗑️",
    });
    if (!ok) return;
    const matchingBatch = batches.find(batch => batch.id === cartBatch.batch_id)
    decrementCartCounter();
    if (matchingBatch) {
      const matchingProduct = products.find(product => product.id === matchingBatch.product_id);
      if (matchingProduct) {
        window.gtag('event', 'remove_from_cart', {
          currency: "BRL",
          value: cartBatch.amount,
          'items': [{
            'item_name': matchingProduct.name,
            'item_id': matchingProduct.id,
            'price': cartBatch.amount,
            'quantity': cartBatch.quantity
          }]
        });
      } else {
        console.error('Matching product not found.');
      }
    } else {
      console.error('Matching batch not found.');
    }
    if (user) {
      try {
        const response = await api.delete(`/api/v1/cart_batches/${cartBatch.id}`);
        if (response.status === 204) {
          const updatedBatches = cartBatches.filter(batch => batch.id !== cartBatch.id);
          setCartBatches(updatedBatches);
          showToast("success", "Produto removido", "O item foi removido do carrinho.");
        } else {
          showToast("error", "Algo deu errado", "Não foi possível remover o produto. Tente novamente.");
        }
      } catch (error) {
        console.error('Error removing cart batch:', error);
        return false;
      }
    } else {
      try {
        const guestCart = JSON.parse(localStorage.getItem('guestCart')) || [];
        const updatedGuestCart = guestCart.filter(item => item.batch_id !== cartBatch.batch_id);
        localStorage.setItem('guestCart', JSON.stringify(updatedGuestCart));
        updateCartState(cartBatch);
        showToast("success", "Produto removido", "O item foi removido do carrinho.");
      } catch (error) {
        console.error('Error removing cart batch:', error);
        return false;
      }
    }
  }

  function updateCartState(cartBatch) {
    const updatedCartBatches = cartBatches.filter(item => item.batch_id !== cartBatch.batch_id);
    console.log(updatedCartBatches)
    setCartBatches(updatedCartBatches);
    const removedProductBatch = batches.find(batch => batch.id === cartBatch.batch_id);
    if (removedProductBatch) {
      const updatedProducts = products.filter(product => product.id !== removedProductBatch.product_id);
      setProducts(updatedProducts);
      const updatedBatches = batches.filter(batch => batch.id !== cartBatch.batch_id);
      setBatches(updatedBatches);
    }
  }


  const totalCartAmount = cartBatches.reduce((acc, batch) => acc + batch.amount, 0);
  const percentageOf120 = (totalCartAmount * 100) / 120;
  const amountLeft = 120 - totalCartAmount;
  let colorScheme;

  if (percentageOf120 < 25) {
    colorScheme = 'red';
  } else if (percentageOf120 < 75) {
    colorScheme = 'yellow';
  } else {
    colorScheme = 'green';
  }


  async function removePayment(e, payment) {
    e.preventDefault()
    const ok = await confirm({
      title: "Remover pedido",
      description: "Tem certeza que deseja remover este pedido pendente?",
      confirmLabel: "Remover",
      cancelLabel: "Cancelar",
      danger: true,
      icon: "⚠️",
    });
    if (!ok) return;
    try {
      const response = await api.delete(`/api/v1/payments/${payment}`);
      if (response.data.success) {
        showToast("success", "Pedido removido", "O pedido pendente foi removido com sucesso.");
        fetchOpenOrders()
      } else {
        showToast("error", "Algo deu errado", "Não foi possível remover o pedido. Tente novamente.");
      }
    } catch (error) {
      console.error('Error removing payment:', error);
      return false;
    }
  }

  const handlePayment = (e, paymentId) => {
    window.location = `/pagamentos/${paymentId}`
  }

  return (
    <Box
      px="10px"
    >
      <BoozenConfirmDialog {...confirmDialogProps} />
      <Box gap='10px' width='100%'>
        {(cartBatches.length <= 0 && loadingPage) && (
          <Box display='flex' justifyContent='center' padding='50px'>
            <Spinner color={theme.colors.primary} margin='auto'/>
          </Box>
        )}
        {(cartBatches.length === 0 && !loadingPage && openOrders.length === 0) && (
          <Text
            textAlign={"center"}
            fontSize={"24px"}
            color={theme.colors.primaryGreen}
            fontWeight={"bold"}
            py='30px'
          >
            Nenhum item adicionado ao carrinho.
          </Text>
        )}

        {/* Pending orders — always visible, even when cart has items */}
        {!loadingPage && openOrders.length > 0 && (
          <Box
            mb={4}
            p={3}
            bg="orange.50"
            borderRadius="12px"
            border="1px solid"
            borderColor="orange.200"
          >
            <Text fontSize="sm" fontWeight="700" color="orange.700" mb={2}>
              Pagamentos pendentes
            </Text>

            {openOrders.slice(-2).map((openBatchOrder) => (
              <Accordion allowToggle key={openBatchOrder?.payment?.id} mb={2}>
                <AccordionItem border="none">
                  <AccordionButton
                    px={2}
                    py={2}
                    borderRadius="8px"
                    _hover={{ bg: "orange.100" }}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box as="span" display="flex" gap={2} alignItems="center" flex="1">
                      {openBatchOrder?.payment?.payment_method === "credit_card" && (
                        <Box display='flex' gap={2} alignItems='center'>
                          <FaCreditCard />
                          <Text fontSize="sm">Cartão de crédito</Text>
                        </Box>
                      )}
                      {openBatchOrder?.payment?.payment_method === "pix" && (
                        <Box display='flex' gap={2} alignItems='center'>
                          <FaMoneyBill />
                          <Text fontSize="sm">Pix</Text>
                        </Box>
                      )}
                    </Box>

                    <Button
                      onClick={(e) => removePayment(e, openBatchOrder?.payment?.id)}
                      size="xs"
                      background="transparent"
                      color="red.400"
                      _hover={{ background: 'transparent', color: 'red.600' }}
                      mr={1}
                    >
                      <FaTrashAlt />
                    </Button>
                    <AccordionIcon />
                  </AccordionButton>

                  <AccordionPanel pb={2} px={2}>
                    {Array.isArray(openBatchOrder?.batch_details) &&
                      openBatchOrder.batch_details.map((batch_order, index) => (
                        <Box key={index}>
                          <Box display={"flex"} flexDirection="column" margin={"6px 0"}>
                            <Box display={"flex"} justifyContent='space-between'>
                              <Text fontSize="xs" fontWeight="500">Produto:</Text>
                              <Text fontSize="xs">
                                {batch_order?.product?.name?.length > 22
                                  ? batch_order.product.name.slice(0, 22) + '...'
                                  : batch_order?.product?.name}
                              </Text>
                            </Box>
                            <Box display={"flex"} justifyContent='space-between'>
                              <Text fontSize="xs" fontWeight="500">Subtotal:</Text>
                              <Text fontSize="xs">
                                {batch_order?.item?.amount?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                              </Text>
                            </Box>
                          </Box>
                        </Box>
                      ))}
                    <Divider my={2} />
                    <Box display={"flex"} justifyContent='space-between' mb={2}>
                      <Text fontSize="xs" fontWeight="700">Total:</Text>
                      <Text fontSize="xs" fontWeight="700">
                        {Array.isArray(openBatchOrder?.batch_orders)
                          ? openBatchOrder.batch_orders.reduce((total, bo) =>
                              total + (bo?.item?.amount || 0), 0
                            ).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                          : 'R$ 0,00'}
                      </Text>
                    </Box>

                    <Button
                      background={theme.colors.primaryGreen}
                      color='white'
                      size="sm"
                      borderRadius="16px"
                      fontSize='xs'
                      width="100%"
                      _hover={{
                        background: "transparent",
                        color: theme.colors.primaryGreen,
                        border: `1px solid ${theme.colors.primaryGreen}`
                      }}
                      onClick={(e) => handlePayment(e, openBatchOrder?.payment?.id)}
                    >
                      Continuar pagamento
                    </Button>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>
            ))}
          </Box>
        )}

        <Box display="flex" flexDirection="column" gap="12px">
  {cartBatches.map((cartBatch) => {
    const batch = batches.find(
      (element) => element.id === cartBatch.batch_id
    );

    const product = products.find(
      (element) => element.id === batch?.product_id
    );

    const photo =
      photos.find(
        (element) => element.product === batch?.product_id
      )?.photo ||
      require("../../assets/images/home-cover.webp");

    return (
      <Box
        key={cartBatch.id}
        bg="white"
        borderRadius="20px"
        p="14px"
        boxShadow="0 8px 24px rgba(0,74,51,.08)"
        border="1px solid rgba(0,74,51,.06)"
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          gap="12px"
        >
          <Image
            src={photo}
            alt={product?.name}
            w="72px"
            h="72px"
            minW="72px"
            borderRadius="16px"
            objectFit="cover"
          />

          <Box flex="1">
            <Text
              fontWeight="700"
              color={theme.colors.primaryGreen}
              fontSize="14px"
              noOfLines={2}
            >
              {product?.name}
            </Text>

            <Text
              mt="4px"
              fontSize="12px"
              color="gray.500"
            >
              {cartBatch.quantity}{" "}
              {batch?.unity_of_measurement}
              {cartBatch.quantity > 1 ? "s" : ""}
              {" • "}
              {cartBatch.quantity *
                product?.quantity_per_box}{" "}
              {product?.size}
            </Text>
          </Box>

          <Button
            onClick={(e) =>
              hendleRemoveCartBatch(e, cartBatch)
            }
            size="sm"
            bg="transparent"
            color={theme.colors.primaryOrange}
            minW="auto"
            p="6px"
            _hover={{
              bg: "rgba(252,143,4,.08)"
            }}
          >
            <FaTrashAlt />
          </Button>
        </Box>

        <Box
          mt="14px"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            display="flex"
            alignItems="center"
            gap="8px"
            border="1px solid rgba(0,74,51,.08)"
            borderRadius="12px"
            p="4px"
          >
            <Button
              size="xs"
              bg={theme.colors.primaryGreen}
              color={theme.colors.primaryOrange}
              borderRadius="8px"
              onClick={() =>
                handleDecrement(cartBatch)
              }
            >
              <BsDash />
            </Button>

            <Text
              minW="24px"
              textAlign="center"
              fontWeight="700"
            >
              {cartBatch.quantity}
            </Text>

            <Button
              size="xs"
              bg={theme.colors.primaryGreen}
              color={theme.colors.primaryOrange}
              borderRadius="8px"
              onClick={() =>
                handleIncrement(cartBatch)
              }
            >
              <BsPlus />
            </Button>
          </Box>

          <Box textAlign="right">
            <Text
              fontSize="11px"
              color="gray.500"
            >
              Total
            </Text>

            <Text
              fontWeight="900"
              color={theme.colors.primaryGreen}
              fontSize="16px"
            >
              {cartBatch.amount.toLocaleString(
                "pt-BR",
                {
                  style: "currency",
                  currency: "BRL",
                }
              )}
            </Text>
          </Box>
        </Box>
      </Box>
    );
  })}
</Box>

        {totalCartAmount < 120 && (<>
          <Progress
            margin="20px auto"
            borderRadius="3px"
            colorScheme={colorScheme}
            width="100%"
            size="sm"
            value={percentageOf120}
          />
          <Text textAlign="center">+ {amountLeft.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} para Frete grátis</Text>
        </>)}
        {totalCartAmount >= 120 && (
          <Box
            mt="20px"
            p="14px"
            bg="rgba(0,74,51,.04)"
            borderRadius="16px"
          >
            <Text
              fontWeight="700"
              color={theme.colors.primaryGreen}
              mb="8px"
            >
              🚚 Frete Grátis
            </Text>

            <Progress
              value={Math.min(percentageOf120, 100)}
              borderRadius="999px"
              colorScheme={
                percentageOf120 < 75
                  ? "orange"
                  : "green"
              }
            />

            <Text
              mt="8px"
              textAlign="center"
              fontSize="13px"
            >
              {totalCartAmount >= 120
                ? "Você ganhou frete grátis!"
                : `Faltam ${amountLeft.toLocaleString(
                    "pt-BR",
                    {
                      style: "currency",
                      currency: "BRL",
                    }
                  )}`}
            </Text>
          </Box>
        )}
        <Box
          mt="20px"
          bg="white"
          p="18px"
          borderRadius="20px"
          boxShadow="0 8px 24px rgba(0,74,51,.08)"
        >
          <Box
            display="flex"
            justifyContent="space-between"
            mb="16px"
          >
            <Text
              fontWeight="600"
              color="gray.600"
            >
              Subtotal
            </Text>

            <Text
              fontWeight="900"
              fontSize="20px"
              color={theme.colors.primaryGreen}
            >
              {totalCartAmount.toLocaleString(
                "pt-BR",
                {
                  style: "currency",
                  currency: "BRL",
                }
              )}
            </Text>
          </Box>

          {cartBatches.length > 0 && (
            <Button
              as="a"
              href="/carrinho"
              w="100%"
              h="52px"
              borderRadius="16px"
              bg={theme.colors.primaryGreen}
              color={theme.colors.primaryOrange}
              fontWeight="900"
              fontSize="15px"
              _hover={{
                transform: "translateY(-2px)",
                boxShadow:
                  "0 10px 24px rgba(0,74,51,.20)"
              }}
            >
              Finalizar Compra
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  )
}
